module.exports = __webpack_public_path__ + "static/5-256810f9ec33ab626c024740dc8f0279.png";